<template>
  <div>
    <el-select
      :value="selected"
      @input="dispatch"
      :placeholder="placeholder || $t('message.guest')"
      filterable
      clearable
      :disabled="disabled"
      :size="size"
      class="d-block"
      :multiple="multiple"
    >
      <el-option
        v-for="(guest, index) in guests"
        :key="'guest-' + index"
        :label="guest.full_name"
        :value="guest.id"
      ></el-option>
    </el-select>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { i18n } from "@/utils/i18n";
export default {
  props: {
    size: {
      default: "small",
    },
    placeholder: {
      default: null,
    },
    id: {
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false      
    },
    guest_id: {
      default: null,
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  watch: {
    id: {
      handler: function () {
        setTimeout(() => {
          this.selected = this.id;
        });
      },
      deep: true,
      immediate: true,
    },
    guest_id: {
      handler: function (newVal, oldVal) {
        if (newVal != oldVal) {
          this.selected = null;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (this.guestsList && this.guestsList.length === 0) 
    {
        this.updateInventory();
    }
  },
  computed: {
    ...mapGetters({
      guestsList: "guest/inventory",
    }),
    guests: function () {
      return !this.guest_id ? this.guestsList : _.filter(this.guestsList, ["id", this.guest_id]);        
    },
  },
  methods: {
    ...mapActions({
      updateInventory: "guest/inventory",
    }),
    dispatch(e) {
      this.$emit("input", e);      
      this.selected = e;
    },
  },
};
</script>
